export const mapOptionsNameToOptionsLabelFormat = (option: {
  value: string;
  name: string;
}): { value: string; label: string } => ({
  value: option.value,
  label: option.name!,
});
